var map = {
	"./android.png": 16,
	"./c1.png": 17,
	"./c2.png": 18,
	"./c3.png": 19,
	"./cf.png": 20,
	"./cs.png": 21,
	"./google.png": 22,
	"./health.png": 23,
	"./solar.png": 24,
	"./tt.png": 25,
	"./vertigo.png": 26
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54;